import { post } from "_src/utils/http";

// 获取nonce
export function getNonce(data) {
  return post("/api/inftspace/auth/get_nonce", {
    ...data,
    isNoNeedToken: true,
  }).then((res) => {
    return res;
  });
}

// 验证签名，获取token
export function authSign(data) {
  return post("/api/inftspace/auth/auth_sign", {
    ...data,
    isNoNeedToken: true,
  }).then((res) => {
    return res;
  });
}

// 验证token 是否过期
export function verifySignExpire(data) {
  return post("/api/inftspace/auth/verify_sign_expire", data).then((res) => {
    return res;
  });
}
